import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormItem from '../../../common/forms/FormItem'
import DatePicker from '../../../common/forms/input/DatePicker'
import { isRequired, validateEndDate } from '../../../../utils/validators'
import CitySelect from '../../../common/forms/select/CitySelect'
import FormFooter from '../../../common/forms/FormFooter'
import TextInput from '../../../common/forms/input/TextInput'

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const LegalManifestCargoForm = ({
  handleSubmit,
  loading,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Ciudad de Origen">
        <Field
          name="sourceCity"
          component={CitySelect}
          isClearable
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Ciudad de Destino">
        <Field
          name="destinationCity"
          component={CitySelect}
          isClearable
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Placa del Bus" required>
        <Field
          name="busLicensePlate"
          component={TextInput}
          placeholder="Placa del Bus"
          type="text"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="primary"
      saveButtonDisabled={loading}
    />
  </Form>
)

LegalManifestCargoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

LegalManifestCargoForm.defaultProps = {
  loading: false,
}

export default reduxForm({
  form: 'LegalManifestCargoForm',
})(LegalManifestCargoForm);